import React, {
    useRef,
    useState,
    useCallback,
    useMemo,
    useEffect,
} from "react";
import "./Course.css";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Divider,
    Grid2,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Modal,
    Stack,
    Step,
    StepLabel,
    Stepper,
    Tab,
    Tabs,
    TextField,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PropTypes from "prop-types";
import {
    useGetCourseDetailMutation,
    useGetCourseDetailsListByIdMutation,
    useGetCourseSubDetailMutation,
    useGetCourseSubDetailsByCourseIdListMutation,
    useGetCourseTrackListMutation,
    useGetCourseTrackEndMutation,
    useGetCourseTrackStartMutation,
    useGetAssignmentMasterMutation,
    useGetAssignmentQuestionListMutation,
    usePostAssignmentTrackStartMutation,
    usePostAssignmentTrackEndMutation,
    useGetAssignmentTrackListMutation,
} from "../../../apiSlice";
import SideBar from "../../Dashboard/StudentDashboard/Sidebar/SideBar";
import Breadcrumb from "../../StudentBreadcrumb/Breadcrumb";
import Loader from "../../Loader";
import { useNavigate } from "react-router-dom";
import {
    AssignmentReturnSharp,
    ConstructionOutlined,
} from "@mui/icons-material";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            className="panelCover"
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const CourseContent = () => {
    const [loading, setLoading] = useState(true);
    const [markAsCompletedLoaderState, setMarkAsCompletedLoaderState] =
        useState(false);
    const [courseData] = useState(() =>
        JSON.parse(sessionStorage.getItem("courseData") || "{}")
    );

    useEffect(() => {
        console.log("courseData ========= ", courseData);
    }, [courseData]);

    const userClassId = sessionStorage.getItem("userClassId");

    useEffect(() => {
        console.log("userClassId ========= ", userClassId);
    }, [userClassId]);
    const [currentSubscription] = useState(() =>
        JSON.parse(sessionStorage.getItem("courseSubscription"))
    );

    // const [currentSubscription] = useState({
    //     courseSubscriptionId: 2,
    //     courseId: 2,
    //     numberOfCourseContentVisible: 3,
    //     schoolId: 9,
    //     classId: 10,
    //     isTrialExpired: false,
    //     classId: 1,
    //     isPaymentDone: false,
    //     subscriptionStartDate: "2025-07-07T11:40:40.31",
    //     subscrptionEndDate: "2025-07-07T11:40:40.31",
    // });

    const isTrialExpired =
        currentSubscription.filter(
            (csd) => csd.courseId === courseData.courseId
        ).isTrialExpired || false;

    const [isPaymentDone] = useState(
        currentSubscription.filter(
            (csd) => csd.courseId === courseData.courseId
        )[0]?.isPaymentDone || false
    );

    useEffect(() => {
        console.log("isPaymentDone >>>>>>>>> ", isPaymentDone);
    }, [isPaymentDone]);

    const numberOfCourseContentVisible =
        currentSubscription.numberOfCourseContentVisible || 3;

    useEffect(() => {
        console.log("isPaymentDone ==== ", isPaymentDone);
        console.log(
            "numberOfCourseContentVisible ======= ",
            numberOfCourseContentVisible
        );
    }, [isPaymentDone, numberOfCourseContentVisible]);

    useEffect(() => {
        console.log("currentSubscription ========= ", currentSubscription);
    }, [currentSubscription]);

    const [userID] = useState(() => JSON.parse(localStorage.getItem("UserID")));

    const navigate = useNavigate();

    // API mutations
    const [studentCourseSubDetailsAPI] = useGetCourseSubDetailMutation();
    const [studentCourseSubDetailsByCourseIdListAPI] =
        useGetCourseSubDetailsByCourseIdListMutation();
    const [studentCourseDetailAPI] = useGetCourseDetailMutation();
    const [courseDetialsListById] = useGetCourseDetailsListByIdMutation();
    const [studentCourseTrackListAPI] = useGetCourseTrackListMutation();
    const [studentCourseTrackStartAPI] = useGetCourseTrackStartMutation();
    const [studentCourseTrackEndAPI] = useGetCourseTrackEndMutation();
    const [studentAssignmentMasterAPI] = useGetAssignmentMasterMutation();
    const [studentAssignmentQuestionListAPI] =
        useGetAssignmentQuestionListMutation();
    const [studentAssignmentTrackStartAPI] =
        usePostAssignmentTrackStartMutation();
    const [studentAssignmentTrackEndAPI] = usePostAssignmentTrackEndMutation();
    const [studentAssignmentTrackListAPI] = useGetAssignmentTrackListMutation();

    // State management
    const [courseSubDetails, setCourseSubDetails] = useState([]);
    const [courseDetails, setCourseDetails] = useState([]);

    useEffect(() => {
        console.log("courseDetails ==== ", courseDetails);
    }, [courseDetails]);

    const [openModal, setOpenModal] = useState(false);
    const [courseTrackData, setCourseTrackData] = useState([]);
    const [showButton, setShowButton] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const [activeStep, setActiveStep] = useState(0);
    const [currentTrackID, setCurrentTrackID] = useState();
    const [activeSegmentIndex, setActiveSegmentIndex] = useState(1);
    const [assignmentTrackList, setAssignmentTrackList] = useState([]);
    const [assignmentTrackIdData, setAssignmentTrackIdData] = useState();

    useEffect(() => {
        console.log("activeSegmentIndex ========== ", activeSegmentIndex);
    });

    const [activeSegmentStatus, setActiveSegmentStatus] = useState(""); //unseen ongoing completed

    useEffect(() => {
        console.log("activeSegmentStatus ========== ", activeSegmentStatus);
    }, [activeSegmentStatus]);

    const [refresh, setRefresh] = useState(0);
    const steps = useMemo(() => ["0%", "25%", "50%", "75%", "100%"], []);
    // const [isDetailMarkedAsCompleted, setIsDetailMarkedAsCompleted] = useState();

    // Timer implementation with refs to avoid re-renders
    const timerRef = useRef(null);
    const timeLeftRef = useRef({ minutes: 0, seconds: 0 });
    const [displayTime, setDisplayTime] = useState("00:00");

    // Format time for display
    const formatTime = (minutes, seconds) => {
        return `${minutes.toString().padStart(2, "0")}:${seconds
            .toString()
            .padStart(2, "0")}`;
    };

    // Update display time without causing re-renders
    const updateDisplayTime = () => {
        setDisplayTime(
            formatTime(timeLeftRef.current.minutes, timeLeftRef.current.seconds)
        );
    };

    // Timer callback using requestAnimationFrame for better performance
    const timerCallback = useCallback(() => {
        if (timeLeftRef.current.seconds > 0) {
            timeLeftRef.current.seconds -= 1;
        } else if (timeLeftRef.current.minutes > 0) {
            timeLeftRef.current.minutes -= 1;
            timeLeftRef.current.seconds = 59;
        } else {
            // Time's up
            setShowButton(true);
            clearInterval(timerRef.current);
            return;
        }
        updateDisplayTime();
    }, []);

    // Start timer with minutes from API
    const startTimer = useCallback(
        (seconds) => {
            // Clear any existing timer
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }

            // Initialize time
            timeLeftRef.current = {
                minutes: 0,
                seconds: seconds,
            };
            updateDisplayTime();
            setShowButton(false);

            // Start new timer
            timerRef.current = setInterval(timerCallback, 1000);
        },
        [timerCallback]
    );

    // Clean up timer on unmount
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, []);

    // Fetch course data
    const fetchData = useCallback(async () => {
        try {
            // const courseSubD = await studentCourseSubDetailsAPI();

            const courseSubD = await studentCourseSubDetailsByCourseIdListAPI(
                courseData.courseId
            );

            const filteredCourseSubDetails =
                courseSubD?.data?.filter(
                    (e) => e.courseId === courseData.courseId
                ) || [];
            const sortedCourseSubDetails = [...filteredCourseSubDetails].sort(
                (a, b) => {
                    if (
                        a.courseSubDetailsPeriority <
                        b.courseSubDetailsPeriority
                    )
                        return -1;
                    if (
                        a.courseSubDetailsPeriority >
                        b.courseSubDetailsPeriority
                    )
                        return 1;
                    return 0;
                }
            );
            setCourseSubDetails(sortedCourseSubDetails);

            console.log("courseSubDetails ==========", courseSubDetails);

            // const courseD = await studentCourseDetailAPI();
            const courseD = await courseDetialsListById(
                String(courseData.courseId)
            );
            // const filteredCourseDetails =
            //     courseD?.data
            //         ?.filter((e) => e.courseId === courseData.courseId)
            //         .slice()
            //         .reverse() || [];

            const filteredCourseDetails = courseD?.data.slice().reverse() || [];

            const sortedCourseDetails = [...filteredCourseDetails].sort(
                (a, b) => {
                    if (a.courseContentPriority < b.courseContentPriority)
                        return -1;
                    if (a.courseContentPriority > b.courseContentPriority)
                        return 1;
                    return 0;
                }
            );
            setCourseDetails(sortedCourseDetails);

            console.log("courseDetials", courseDetails);

            const courseT = await studentCourseTrackListAPI();
            const filteredCourseTrack =
                courseT?.data?.filter(
                    (e) =>
                        e.courseId === courseData.courseId &&
                        e.userID === userID
                ) || [];
            setCourseTrackData(filteredCourseTrack);

            console.log("courseTrackData =========", courseTrackData);
            setCurrentTrackID(
                filteredCourseTrack?.filter(
                    (e) => e.courseCompleted === false
                )[0]?.courseTrackId
            );
            const courseDetailIdFromTrackList = filteredCourseTrack?.filter(
                (e) => e.courseCompleted === false
            )[0]?.courseDetailID;
            const indexFromCourseDetails = filteredCourseDetails?.filter(
                (e) => e.courseDetailId === courseDetailIdFromTrackList
            )[0]?.courseContentPriority;
            console.log("Track Data", filteredCourseTrack);

            if (filteredCourseTrack.length === 0) {
                setActiveSegmentIndex(1);
                const firstElement = filteredCourseDetails?.filter(
                    (e) => e.courseContentPriority === 1
                )[0];
                studentCourseTrackStartAPI({
                    courseTrackId: 0,
                    courseDetailID: firstElement?.courseDetailId,
                    userID: 0,
                    courseSubdetailsId: firstElement?.courseSubdetailsId,
                    courseId: firstElement?.courseId,
                }).then((response) => setCurrentTrackID(response.data.trackid));
                setRefresh((prev) => prev + 1);
            } else if (
                filteredCourseTrack.filter((e) => e.courseCompleted === false)
                    .length > 0
            ) {
                setActiveSegmentIndex(indexFromCourseDetails);
            } else if (
                filteredCourseTrack.filter((e) => e.courseCompleted === true)
                    .length === filteredCourseDetails.length
            ) {
                setActiveSegmentIndex(1);
            }

            // Initialize timer after all data loads
            if (filteredCourseDetails.length > 0) {
                const seconds =
                    filteredCourseDetails[0]?.courseAllotedTime || 2;
                startTimer(seconds);
            }
        } catch (error) {
            console.error("Error fetching course data:", error);
        } finally {
            setLoading(false);
        }
    }, [courseData.courseId, courseTrackData.length, refresh]);

    // Load data on mount
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        const assignmentTrackStartHandle = async () => {
            try {
                if (courseSubDetails) {
                    const assignmentTrackListResponse =
                        await studentAssignmentTrackListAPI(
                            courseData.courseId
                        );

                    const trackData = assignmentTrackListResponse?.data;

                    console.log("trackData ======= ", trackData);

                    setAssignmentTrackList(assignmentTrackListResponse.data);

                    console.log(
                        "assignmentTrackList ======= ",
                        assignmentTrackList
                    );
                    console.log(
                        "AssignmentTrackListData Length >>>>>>>> ",
                        assignmentTrackList.length
                    );

                    if (trackData.length === 0) {
                        const priority1CourseSubDetail =
                            courseSubDetails?.filter(
                                (cd) => cd.courseSubDetailsPeriority === 1
                            )[0];

                        console.log(
                            "priority1CourseSubDetail >>>>>>>> ",
                            priority1CourseSubDetail
                        );

                        const firstAssignmentData =
                            priority1CourseSubDetail?.assignments?.filter(
                                (asgn) => asgn.assignmentCounter === 1
                            )[0];

                        console.log(
                            "firstAssignmentData >>>>>>>> ",
                            firstAssignmentData
                        );

                        if (firstAssignmentData) {
                            await studentAssignmentTrackStartAPI({
                                assignmentId: firstAssignmentData?.assignmentId,
                            });
                        }
                    } else {
                    }
                }
            } catch (e) {
                console.log("Error", e);
            } finally {
                console.log(
                    ">>>>>>>>>>>>>>> ASSIGNMENT TRACK API COMPLETED <<<<<<<<<,"
                );
            }
        };

        assignmentTrackStartHandle();
    }, [courseSubDetails, assignmentTrackList?.length, refresh]);

    useEffect(() => {
        console.log("assignmentTrackList >>>>>>>>>>>>>> ", assignmentTrackList);
    }, [assignmentTrackList]);

    // useEffect(() => {
    //   if (courseTrackData.length === 0 && courseDetails.length !== 0 && !loading) {
    //     const firstElement = courseDetails?.filter(e=> e.courseContentPriority === 1)[0];
    //     studentCourseTrackStartAPI({
    //       courseTrackId: 0,
    //       courseDetailID: firstElement?.courseDetailId,
    //       userID: 0,
    //       courseSubdetailsId: firstElement?.courseSubdetailsId,
    //       courseId: firstElement?.courseId
    //     }).then(response => setCurrentTrackID(response.data.trackid));
    //   }
    // }, [courseTrackData, loading]);

    // Assignment Master API Calling
    useEffect(() => {
        const fetchAssignmentMaster = async () => {
            const response = await studentAssignmentMasterAPI();
            const res = await studentAssignmentQuestionListAPI();

            console.log("ASSIGNMENTMASTER ====== ", response.data[0]);
            console.log("ASSIGNMENTQUESTIONLIST ====== ", res.data[0]);
        };

        fetchAssignmentMaster();
    }, []);

    useEffect(() => {
        console.log("active index-------------", activeSegmentIndex);
        console.log("coursedetails ---- ", courseDetails);
        const courseDetailIdFromCourseDetails = courseDetails?.filter(
            (e) => e.courseContentPriority === activeSegmentIndex
        )[0]?.courseDetailId;

        console.log(
            "courseDetailIdFromCourseDetails ====== ",
            courseDetailIdFromCourseDetails
        );

        console.log(
            "activeSegmentIndex -- status -- activeSegmentIndex ========== ",
            activeSegmentIndex
        );

        console.log(
            " length track ====== ",
            courseTrackData.filter(
                (e) => e.courseDetailID === courseDetailIdFromCourseDetails
            ).length
        );

        if (
            courseTrackData.filter(
                (e) => e.courseDetailID === courseDetailIdFromCourseDetails
            ).length === 0
        ) {
            setActiveSegmentStatus("unseen");
        } else {
            if (
                courseTrackData.filter(
                    (e) => e.courseDetailID === courseDetailIdFromCourseDetails
                )[0].courseCompleted === false
            ) {
                setActiveSegmentStatus("ongoing");
            } else if (
                courseTrackData.filter(
                    (e) => e.courseDetailID === courseDetailIdFromCourseDetails
                )[0].courseCompleted === true
            ) {
                setActiveSegmentStatus("completed");
            }
        }
    }, [activeSegmentIndex, courseDetails]);

    // Segment navigation
    const setMarkAsCompletedSegment = useCallback(() => {
        setMarkAsCompletedLoaderState(true);
        const nextIndex = activeSegmentIndex + 1;
        // const nextIndex = currentSubscription

        const courseID_END = courseDetails?.filter(
            (e) => e.courseContentPriority === activeSegmentIndex
        )[0]?.courseId;

        const courseSubDetailID_END = courseDetails?.filter(
            (e) => e.courseContentPriority === activeSegmentIndex
        )[0]?.courseSubdetailsId;

        const courseDetailID_END = courseDetails?.filter(
            (e) => e.courseContentPriority === activeSegmentIndex
        )[0]?.courseDetailId;

        const courseTrackID_END = courseTrackData?.filter(
            (e) => e.courseDetailID === courseDetailID_END
        )[0]?.courseTrackId;

        // Track completion
        studentCourseTrackEndAPI({
            courseTrackId: courseTrackID_END,
            userID: 0,
            courseDetailID: courseDetailID_END,
            courseSubdetailsId: courseSubDetailID_END,
            courseId: courseID_END,
        });

        console.log("trackEndData =======", {
            courseTrackId: courseTrackID_END,
            userID: 0,
            courseDetailID: courseDetailID_END,
            courseSubdetailsId: courseSubDetailID_END,
            courseId: courseID_END,
        });

        // Start next segment
        const courseID_START = courseDetails?.filter(
            (e) => e.courseContentPriority === nextIndex
        )[0]?.courseId;

        const courseSubDetailID_START = courseDetails?.filter(
            (e) => e.courseContentPriority === nextIndex
        )[0]?.courseSubdetailsId;

        const courseDetailID_START = courseDetails?.filter(
            (e) => e.courseContentPriority === nextIndex
        )[0]?.courseDetailId;

        studentCourseTrackStartAPI({
            courseTrackId: 0,
            courseDetailID: courseDetailID_START,
            userID: 0,
            courseSubdetailsId: courseSubDetailID_START,
            courseId: courseID_START,
        })
            .then((response) => setCurrentTrackID(response.data.trackid))
            .then(() => {
                // window.location.reload();
                setTimeout(() => {
                    setMarkAsCompletedLoaderState(false);
                }, 1000);

                setRefresh((prev) => prev + 1);
            });

        // setTimeout(() => {
        //   setRefresh((prev) => prev + 1);
        // }, 1000)
    }, [activeSegmentIndex, courseDetails, startTimer, loading]);

    const setNextSegment = useCallback(() => {
        const nextIndex = activeSegmentIndex + 1;
        setActiveSegmentIndex(nextIndex);
        const nextSegmentMinutes =
            courseDetails[nextIndex]?.courseAllotedTime || 0;
        startTimer(nextSegmentMinutes);
    }, [activeSegmentIndex, courseDetails, startTimer]);

    const setPrevSegment = useCallback(() => {
        const prevIndex = activeSegmentIndex - 1;
        setActiveSegmentIndex(prevIndex);
        const prevSegmentMinutes =
            courseDetails[prevIndex]?.courseAllotedTime || 0;
        startTimer(prevSegmentMinutes);
    }, [activeSegmentIndex, courseDetails, startTimer]);

    const handleTabChange = useCallback((event, newValue) => {
        setTabValue(newValue);
    }, []);
    const courseTotalModule = useMemo(
        () => courseDetails.length,
        [courseDetails]
    );
    const courseProgress = useMemo(
        () => courseTrackData?.filter((e) => e.courseCompleted === true).length,
        [courseTrackData]
    );
    const percentCompleted = useMemo(
        () => (courseProgress * 100) / courseTotalModule,
        [courseProgress, courseTotalModule]
    );
    useEffect(() => {
        let newStep = 0;
        if (percentCompleted === 100) {
            newStep = 4;
        } else if (percentCompleted > 75) {
            newStep = 3;
        } else if (percentCompleted > 50) {
            newStep = 2;
        } else if (percentCompleted > 25) {
            newStep = 1;
        }
        setActiveStep(newStep);
    }, [percentCompleted]);

    const [commentTextValue, setCommentTextValue] = useState("");

    const handleCommentSubmit = (e) => {
        e.preventDefault();
        // Add your submission logic here
    };

    const handleAssignmentRedirection = (AssignmentID, AssignmentTitle) => {
        console.log(
            `AssignmentID --> ${AssignmentID} | AssignmentTitle --> ${AssignmentTitle}`
        );

        localStorage.setItem("assignmentID", AssignmentID);
        navigate("/StudentDashboard/AssignmentContent");
    };

    if (loading) {
        return (
            <>
                <SideBar />
                <Box
                    sx={{
                        flexGrow: 1,
                        position: "relative",
                        left: "60px",
                        width: "calc(100% - 60px)",
                        padding: "20px",
                        height: "100vh",
                        backgroundColor: "#F8F9FD",
                    }}
                >
                    <Breadcrumb />
                    <Loader />
                </Box>
            </>
        );
    }

    // setTimeout(() => {
    //     const iframe = document.querySelector("iframe.ql-video");

    //     if (!iframe) {
    //         console.log("frame not found.");
    //         return;
    //     }

    //     const iframeDoc =
    //         iframe.contentDocument || iframe.contentWindow.document;

    //     const video = iframeDoc?.querySelector("video");

    //     if (video) {
    //         console.log("Video found!");
    //         console.log("Duration:", video.duration);
    //         console.log("Current time:", video.currentTime);
    //         console.log("Paused:", video.paused);
    //         console.log(" Volume:", video.volume);
    //     } else {
    //         console.log("Video not found in iframe yet.");
    //     }
    // }, 3000); // wait 3 seconds for iframe to load

    return (
        <>
            <SideBar />
            <Box
                sx={{
                    flexGrow: 1,
                    position: "relative",
                    left: "60px",
                    width: "calc(100% - 60px)",
                    padding: "20px",
                    height: "100vh",
                    overflowY: "scroll",
                    backgroundColor: "#F8F9FD",
                }}
            >
                <Breadcrumb />
                <Grid2 container spacing={4}>
                    <Grid2 size={8} container direction="column" spacing={2}>
                        <Grid2
                            container
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography
                                variant="h4"
                                sx={{ color: "text.primary" }}
                            >
                                {courseDetails[activeSegmentIndex - 1]
                                    ?.courseHeading || ""}
                            </Typography>
                        </Grid2>

                        {/* tab section */}
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <Tabs
                                value={tabValue}
                                onChange={handleTabChange}
                                aria-label="basic tabs example"
                                textColor="inherit"
                                indicatorColor="secondary"
                            >
                                <Tab label="OverView" {...a11yProps(0)} />
                                <Tab label="Comments" {...a11yProps(1)} />
                            </Tabs>
                        </Box>

                        {/* course content display section */}
                        <CustomTabPanel value={tabValue} index={0}>
                            {/* <div
                                style={{ width: "100%", filter: "blur(10px)" }}
                                dangerouslySetInnerHTML={{
                                    __html:
                                        courseDetails.filter(
                                            (e) =>
                                                e.courseContentPriority ===
                                                activeSegmentIndex
                                        )[0]?.courseContent || "",
                                }}
                            /> */}
                            <div
                                style={{
                                    position: "relative",
                                    width: "100%",
                                    // border: "2px solid purple",
                                    overflow: "hidden",
                                }}
                            >
                                {/* Content container (blurred for trial users) */}
                                <div
                                    style={{
                                        width: "100%",
                                        // filter: currentSubscription.isTrialExpired === false
                                        //     ? "blur(5px)"
                                        //     : "none",
                                        filter:
                                            isPaymentDone === false &&
                                            activeSegmentIndex >
                                                numberOfCourseContentVisible
                                                ? "blur(5px)"
                                                : "none",
                                        // pointerEvents:
                                        //     currentSubscription.isTrialExpired ===
                                        //     false
                                        //         ? "auto" // disables interaction
                                        //         : "none",
                                        // pointerEvents:
                                        //     isPaymentDone === false &&
                                        //     activeSegmentIndex >
                                        //         numberOfCourseContentVisible
                                        //         ? "auto" // disables interaction
                                        //         : "none",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            courseDetails.filter(
                                                (e) =>
                                                    e.courseContentPriority ===
                                                    activeSegmentIndex
                                            )[0]?.courseContent || "",
                                    }}
                                />

                                {/* Blocking overlay with message */}
                                {isPaymentDone === false &&
                                    activeSegmentIndex >
                                        numberOfCourseContentVisible && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                backgroundColor:
                                                    "rgba(255, 255, 255, 0.6)",
                                                display: "flex",
                                                alignItems: "start",
                                                justifyContent: "center",
                                                fontWeight: "700",
                                                fontSize: "1.2rem",
                                                zIndex: 10,
                                                backdropFilter: "blur(15px)",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    // border: "2px solid red",
                                                    height: "20%",
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "center",
                                                        alignItems: "center",
                                                        gap: "12px",
                                                        scale: "120%",
                                                        // border: "2px solid yellow"
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            rotate: "10deg",
                                                            aspectRatio: "1/1",
                                                            width: "40px",
                                                        }}
                                                    >
                                                        {/* Background Image Blur */}
                                                        <img
                                                            src="/lock.svg"
                                                            style={{
                                                                width: "100%",
                                                                height: "auto",
                                                                filter: "blur(15px) brightness(1.75)",
                                                            }}
                                                        />
                                                        {/* Front Image */}
                                                        <img
                                                            src="/lock.svg"
                                                            style={{
                                                                width: "100%",
                                                                height: "auto",
                                                                position:
                                                                    "absolute",
                                                                inset: 0,
                                                                filter: "brightness(1.1)",
                                                            }}
                                                        />
                                                    </Box>
                                                    <p
                                                        style={{
                                                            color: "#f2424b",
                                                        }}
                                                    >
                                                        Upgrade to view this
                                                        content.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                            </div>
                        </CustomTabPanel>

                        {/* comment section */}
                        <CustomTabPanel value={tabValue} index={1}>
                            <Box
                                component="form"
                                onSubmit={handleCommentSubmit}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 2,
                                    margin: "auto",
                                }}
                            >
                                <TextField
                                    label="Your Message"
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    fullWidth
                                    value={commentTextValue}
                                    onChange={(e) =>
                                        setCommentTextValue(e.target.value)
                                    }
                                />
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="secondary"
                                    sx={{ alignSelf: "flex-end" }}
                                >
                                    Submit
                                </Button>
                            </Box>
                        </CustomTabPanel>
                    </Grid2>

                    <Grid2 size={4}>
                        <Grid2
                            sx={{
                                width: "100%",
                                background: "#ffffff",
                                padding: "20px",
                                borderRadius: "6px",
                            }}
                            container
                            spacing={3}
                            direction={"column"}
                        >
                            <Stack spacing={1}>
                                <Typography variant="h6">
                                    Course Progress
                                </Typography>
                                <Typography variant="body1">
                                    {courseProgress}/{courseTotalModule}
                                </Typography>
                                <Box sx={{ padding: "10px 0", width: "100%" }}>
                                    <Stepper
                                        activeStep={activeStep}
                                        alternativeLabel
                                    >
                                        {steps.map((label) => (
                                            <Step key={label}>
                                                <StepLabel>{label}</StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>
                                </Box>

                                <Grid2 container justifyContent="space-between">
                                    <Button
                                        color="secondary"
                                        variant="outlined"
                                        onClick={setPrevSegment}
                                        disabled={activeSegmentIndex === 1}
                                    >
                                        Prev
                                    </Button>
                                    {activeSegmentStatus === "ongoing" ||
                                    activeSegmentStatus === "unseen" ? (
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            {showButton ? (
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    loading={
                                                        markAsCompletedLoaderState
                                                    }
                                                    onClick={() => {
                                                        isPaymentDone === false
                                                            ? activeSegmentIndex <=
                                                              numberOfCourseContentVisible
                                                                ? setMarkAsCompletedSegment()
                                                                : setOpenModal(
                                                                      true
                                                                  )
                                                            : setMarkAsCompletedSegment();
                                                    }}
                                                >
                                                    {/* {markAsCompletedLoaderState
                                                        ? "loading ..."
                                                        : "Mark As Completed"} */}
                                                    Mark As Completed
                                                </Button>
                                            ) : (
                                                <Typography variant="h6">
                                                    Time Left: {displayTime}
                                                </Typography>
                                            )}
                                        </Box>
                                    ) : (
                                        <Button
                                            color="secondary"
                                            variant="outlined"
                                            onClick={setNextSegment}
                                            disabled={
                                                activeSegmentIndex ===
                                                courseDetails?.length
                                            }
                                        >
                                            Next
                                        </Button>
                                    )}
                                </Grid2>
                            </Stack>

                            <Box
                                sx={{
                                    marginTop: "0px",
                                    padding: "0 20px",
                                    background: "#F8F8FA",
                                    borderRadius: "6px",
                                }}
                            >
                                {courseSubDetails?.map((entry, index) => (
                                    <Accordion
                                        defaultExpanded={
                                            courseTrackData?.filter(
                                                (e) =>
                                                    e.courseCompleted === false
                                            )[0]?.courseSubdetailsId ===
                                            entry.courseSubdetailsId
                                        }
                                        key={entry.courseSubdetailsId}
                                        sx={{
                                            background: "transparent",
                                            boxShadow: "none",
                                        }}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            sx={{ padding: "0" }}
                                        >
                                            <Box
                                                width={"100%"}
                                                display={"flex"}
                                                justifyContent={"space-between"}
                                            >
                                                <Typography
                                                    component="span"
                                                    sx={
                                                        {
                                                            // border: "2px solid red",
                                                        }
                                                    }
                                                >
                                                    {entry.courseTopicName}
                                                </Typography>
                                                <Typography component="span">
                                                    {
                                                        entry.courseTopicDescription
                                                    }
                                                </Typography>
                                            </Box>
                                        </AccordionSummary>
                                        <Divider variant="middle" />
                                        <AccordionDetails>
                                            <Grid2 item>
                                                <List dense={false}>
                                                    {courseDetails
                                                        ?.filter(
                                                            (e) =>
                                                                e.courseSubdetailsId ===
                                                                entry.courseSubdetailsId
                                                        )
                                                        .map((subEntry) => (
                                                            <ListItem
                                                                sx={{
                                                                    position:
                                                                        "relative",
                                                                    // border: "2px solid green",
                                                                    cursor: courseTrackData?.filter(
                                                                        (e) =>
                                                                            e.courseDetailID ===
                                                                            subEntry.courseDetailId
                                                                    )[0]
                                                                        ? "pointer"
                                                                        : "default",
                                                                }}
                                                                key={
                                                                    subEntry.courseDetailId
                                                                }
                                                                onClick={() =>
                                                                    courseTrackData?.filter(
                                                                        (e) =>
                                                                            e.courseDetailID ===
                                                                            subEntry.courseDetailId
                                                                    )[0]
                                                                        ? setActiveSegmentIndex(
                                                                              courseDetails?.filter(
                                                                                  (
                                                                                      e
                                                                                  ) =>
                                                                                      e.courseDetailId ===
                                                                                      subEntry.courseDetailId
                                                                              )[0]
                                                                                  ?.courseContentPriority
                                                                          )
                                                                        : ""
                                                                }
                                                            >
                                                                {/* lock icons display logic */}
                                                                {isPaymentDone ===
                                                                    false &&
                                                                subEntry.courseContentPriority !==
                                                                    numberOfCourseContentVisible &&
                                                                subEntry.courseContentPriority >
                                                                    numberOfCourseContentVisible ? (
                                                                    <Box
                                                                        sx={{
                                                                            position:
                                                                                "absolute",
                                                                            top: -8,
                                                                            right: -10,
                                                                            rotate: "10deg",
                                                                            zIndex: 10,
                                                                            aspectRatio:
                                                                                "1/1",
                                                                            width: "28px",
                                                                        }}
                                                                    >
                                                                        {/* Background Image Blur */}
                                                                        <img
                                                                            src="/lock.svg"
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "auto",
                                                                                filter: "blur(15px) brightness(1.75)",
                                                                            }}
                                                                        />
                                                                        {/* Front Image */}
                                                                        <img
                                                                            src="/lock.svg"
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "auto",
                                                                                position:
                                                                                    "absolute",
                                                                                inset: 0,
                                                                                filter: "brightness(1.1)",
                                                                            }}
                                                                        />
                                                                    </Box>
                                                                ) : null}
                                                                <ListItemAvatar>
                                                                    {courseTrackData?.filter(
                                                                        (e) =>
                                                                            e.courseDetailID ===
                                                                            subEntry.courseDetailId
                                                                    )[0]
                                                                        ?.courseCompleted ===
                                                                    true ? (
                                                                        <CheckCircleIcon color="secondary" />
                                                                    ) : (
                                                                        <PlayCircleFilledWhiteOutlinedIcon />
                                                                    )}
                                                                </ListItemAvatar>
                                                                {courseTrackData?.filter(
                                                                    (e) =>
                                                                        e.courseDetailID ===
                                                                        subEntry.courseDetailId
                                                                )[0] ? (
                                                                    <ListItemText
                                                                        primary={
                                                                            <Typography
                                                                                variant="h5"
                                                                                sx={{
                                                                                    fontWeight:
                                                                                        "600",
                                                                                }}
                                                                            >
                                                                                {
                                                                                    subEntry.courseHeading
                                                                                }
                                                                            </Typography>
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <ListItemText
                                                                        primary={
                                                                            <Typography variant="h5">
                                                                                {
                                                                                    subEntry.courseHeading
                                                                                }
                                                                            </Typography>
                                                                        }
                                                                    />
                                                                )}
                                                            </ListItem>
                                                        ))}
                                                    {/* ASSIGNMENT */}
                                                    {entry.assignments.length !=
                                                        0 &&
                                                        entry.assignments.map(
                                                            (asgn) => (
                                                                <Box
                                                                    sx={{
                                                                        position:
                                                                            "relative",
                                                                    }}
                                                                >
                                                                    <ListItem
                                                                        sx={{
                                                                            cursor:
                                                                                isPaymentDone ===
                                                                                true
                                                                                    ? "pointer"
                                                                                    : "default",
                                                                        }}
                                                                        onClick={() => {
                                                                            isPaymentDone ===
                                                                                true &&
                                                                                handleAssignmentRedirection(
                                                                                    asgn.assignmentId,
                                                                                    asgn.assignmentTitle
                                                                                );
                                                                        }}
                                                                    >
                                                                        <ListItemAvatar>
                                                                            <AssignmentIcon />
                                                                        </ListItemAvatar>
                                                                        <ListItemText>
                                                                            {/* Assignment Title Here */}
                                                                            {
                                                                                asgn.assignmentTitle
                                                                            }
                                                                        </ListItemText>
                                                                    </ListItem>
                                                                    {/* lock icon if the payment is not done for subscription model */}
                                                                    {isPaymentDone ===
                                                                        false && (
                                                                        <Box
                                                                            sx={{
                                                                                position:
                                                                                    "absolute",
                                                                                top: -8,
                                                                                right: -10,
                                                                                rotate: "10deg",
                                                                                zIndex: 10,
                                                                                aspectRatio:
                                                                                    "1/1",
                                                                                width: "28px",
                                                                            }}
                                                                        >
                                                                            {/* Background Image Blur */}
                                                                            <img
                                                                                src="/lock.svg"
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "auto",
                                                                                    filter: "blur(15px) brightness(1.75)",
                                                                                }}
                                                                            />
                                                                            {/* Front Image */}
                                                                            <img
                                                                                src="/lock.svg"
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "auto",
                                                                                    position:
                                                                                        "absolute",
                                                                                    inset: 0,
                                                                                    filter: "brightness(1.1)",
                                                                                }}
                                                                            />
                                                                        </Box>
                                                                    )}
                                                                </Box>
                                                            )
                                                        )}
                                                </List>
                                            </Grid2>
                                        </AccordionDetails>
                                    </Accordion>
                                ))}
                            </Box>
                        </Grid2>
                    </Grid2>
                </Grid2>
                <Modal open={openModal} onClose={() => setOpenModal(false)}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 600,
                            bgcolor: "background.paper",
                            borderRadius: "10px",
                            // border: "2px solid #000",
                            boxShadow: 24,
                            p: 4,
                        }}
                    >
                        <Typography
                            id="modal-modal-title"
                            variant="h2"
                            component="h2"
                            color="#f2424b"
                            sx={{
                                fontWeight: 700,
                            }}
                        >
                            Trial Access
                        </Typography>
                        <Typography
                            id="modal-modal-description"
                            sx={{
                                mt: 2,
                                textAlign: "center",
                            }}
                        >
                            {/* Courses are limited in Trial Access */}
                            Your current trial plan offers limited access to
                            courses. Upgrade to a full subscription.
                        </Typography>
                    </Box>
                </Modal>
            </Box>
        </>
    );
};

export default CourseContent;
